<template>
    <div class="search-page">
        <div class="navbar" @click="goBack">
            <div style="margin-right: 10px;">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div>看点小故事</div>
        </div>
        <div class="search-bar">
            <el-input v-model="searchQuery.search_keywords" placeholder="请输入书名/bookid">
              <el-button slot="append" @click="searchByKeywords" icon="el-icon-search"></el-button></el-input>
        </div>
        <div class="book-content">
            
            <div v-if="bookList.length" class="books">
            <mobileBook v-for="(item, index) in bookList" :book-info="item" :key="index" />
          </div>
          <el-empty v-else description="没有找到该书籍"></el-empty>

          <div class="pagination">
            <el-pagination :hide-on-single-page="true" ref="pagination" background  layout="prev, pager, next" mini  :pager-count="3" :total="totalPage" @current-change="currentChange">
          </el-pagination>
          </div>
        </div>
    </div>
</template>

<script>
import { getBookList } from '../../api/index'
import mobileBook from '../home/cpns/mobileBook.vue'
    export default {
        name: 'Search',
        components: {
            mobileBook
        },
        data(){
            return {
                searchQuery: {
                category_ids: 0,
                search_time: 0,
                page: 1,
                page_size: 10,
                search_keywords: ''
                },
                bookList:[],
                totalPage: 0,
            }
        },
        methods:{
            //搜索内容
            async searchByKeywords(){
                if(this.searchQuery.search_keywords.trim()==''){
                    this.$message('请输入内容')
                    return 
                }
                const res = await getBookList(this.searchQuery)
                this.totalPage = parseInt(res.data.page_info.total)
                this.bookList = res.data.data
            },
            currentChange(e) {
            this.searchQuery.page = e
            this.searchByKeywords()
            },
            goBack(){
                this.$router.go(-1)
            }
        }
    }
</script>

<style lang="scss" scoped>
.search-page {
    width: 100%;
    padding-top: 84px;
    .navbar {
    position: fixed;
    top: 0;
    width: 100%;
    height: 44px;
    background: #f1cec2;
    display: flex;
    align-items: center;
    padding-left: 10px;
    }
    .search-bar {
        position: fixed;
        top: 44px;
        width: 100%;
    }
    .book-content {
        height: calc(100vh - 88px);
        padding: 10px 15px;
        overflow: scroll;
    }
    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px auto 30px;
    }
}
</style>